import { ReactElement, ReactNode } from 'react';
import { useFetchTask } from '../../queries';
import { TaskContext } from './context';

type TaskProviderProps = {
    readonly taskId: string;
    readonly children?: ReactNode;
};
export function TaskProvider(props: TaskProviderProps): ReactElement {
    const { taskId, children } = props;

    const { status, task, refetch } = useFetchTask(taskId);

    return (
        <TaskContext.Provider
            value={{
                task: task ?? null,
                status,
                refetch
            }}
        >
            {children}
        </TaskContext.Provider>
    );
}
